import { CountryDto } from "./countryDto";
import { DocumentTypeDto } from "./documentTypeDto";
import { ThematicDto } from "./thematicDto";

export class SupportDto {
  supportESId: string;
  supportId: number;
  categoryId: number;
  title: string;
  pathSupport: string;
  pathImage: string;
  urlImage: string;
  urlSupport: string;
  documentTypeId: number;
  language: string;
  listCountry: CountryDto[];
  listThematic: ThematicDto[];
  documentType: DocumentTypeDto;
  dateSupport: string;
  download: boolean;
  numberDownload: number;
  numberView: number;
}
